import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["style", "className"];
import React, { forwardRef } from 'react';
import { useStyles, StyleSheet } from '@rexlabs/styling';
var defaultStyles = StyleSheet({
  reset: {
    border: 'none',
    margin: 0,
    padding: 0,
    width: 'auto',
    overflow: 'visible',
    cursor: 'inherit',
    background: 'transparent',

    /* inherit font & color from ancestor */
    color: 'inherit',
    font: 'inherit',

    /* Normalize `line-height`. Cannot be changed from `normal` in Firefox 4+. */
    lineHeight: 'normal'
  }
});
export var Button = /*#__PURE__*/forwardRef(function Button(_ref, ref) {
  var style = _ref.style,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var s = useStyles(defaultStyles);
  return /*#__PURE__*/React.createElement("button", _extends({}, s.with('reset')({
    style: style,
    className: className
  }), props, {
    ref: ref
  }));
});